module.exports = __webpack_public_path__ + "img/11.a9e9cf73.jpg";